import React, { useContext, useState } from 'react'
import {Row, Col, Card, Badge } from "react-bootstrap";
import dateFormat from 'dateformat';
import Rating from '@mui/material/Rating';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ModalStyle from '../../data/ModalStyle';

import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';
import { AuthContext } from '../../context/AuthContext';
const BugCourseCard = ({bug,bounty_id}) => {
  const [popup, setpopup] = useState(false)
  const { user } = useContext(AuthContext);
  // State variables for form inputs and files
  const [report, setReport] = useState('');
  const [submission, setSubmission] = useState(null);
 
  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''

  });


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate that all fields are filled
    if (!submission) {
        setOpen({ message: 'Please fill all fields and select both files.', type: 'error', open: true });
        return;
    }

    // Validate file type (only ZIP files allowed)
    const allowedTypes = ['application/pdf'];
    if (!submission || !allowedTypes.includes(submission.type)) {
        setOpen({ message: 'Only PDF files are allowed.', type: 'error', open: true });
        return;
    }

    const formData = new FormData();
    formData.append('report', report);
    formData.append('submission', submission);
    formData.append("session", user.SessionId);
    formData.append('bounty_id',bounty_id)

    try {
        // Send POST request to PHP API
        const response = await axios.post(ENDPOINT + 'bounty-submission.php', formData, SecurityHeaders);
        if (response) {
            if (response.data.status === "success") {
                setOpen({ type: 'success', message: 'Files uploaded successfully.', open: true });
                setpopup(false);
                setReport('');
                setSubmission(null);
            } else {
                setOpen({ type: 'error', message: `Error uploading files: ${response.data.message}`, open: true });
            }
        }
    } catch (error) {
        setOpen({ type: 'error', message: `Error uploading files: ${error.message}`, open: true });
    }
};

  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <>
         <Snackbar open={open.open} onClose={handleClose} autoHideDuration={4000} >
            <Alert
              
              severity={open.type === 'success' ? 'success' : 'error'}
              onClose={() => {}}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {open.message}
            </Alert>
          </Snackbar>
      
      <Modal
  open={popup}
  onClose={()=>setpopup(false)}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={ModalStyle} className="p-3 col-lg-4 col-md-5 col-sm-6 col-11">
  <div>
        <div className="bg-white rounded shadow  col-12 p-5">
          <h1 className='text-center'>Report Submission</h1>
          <form onSubmit={handleSubmit}>
            <div>
              <label>Report:</label>
              <input
                className='form-control mt-2'
                type="text"
                value={report}
                accept="application/pdf"               
                onChange={(e) => setReport(e.target.value)}
              />
            </div>
            <div>
              <label className='mt-2'>Submission:</label>
              <input
                className='form-control mt-2'
                type="file"
                accept="application/pdf"
                onChange={(e) => setSubmission(e.target.files[0])}
              />
            </div>
            <div className='mt-3 d-flex justify-content-center'>
              <button className='btn btn-primary' type="submit">
                Upload
              </button>
            </div>
         

           
        
          </form>
        </div>
      </div>

  </Box>
</Modal>
       <Card className="p-4">
          <Row className='justify-content-between' >
            <Col md={8}>
              <h2>{bug.bounty_title} - Bug Bounty</h2>
              <p> {bug.category} - {bug.company_name}</p>
              <Badge className='mt-2' bg="secondary">Updated</Badge>
              <p className='mt-2' >🛒 eCommerce • 🛡 Safe Harbor</p>
              {/* <p>{bug.rating}</p> */}
              <div className="d-flex mt-2">
                <strong>Scope Rating:</strong>  <Rating className=' ms-2' name="read-only" value={+bug.rating} readOnly /> <p>({bug.rating} out of 5)</p>
              </div>
            </Col>
            <Col md={2} sm={3} className="">
              <img src={bug.image} alt="Logo" className="img-fluid" />
            </Col>
          </Row>

          <Row className=" align-items-start mt-4">
            <Col md={6}>
              <div className="d-flex">
                <strong>Testing Period:</strong> {bug.status}  
                <p className="ms-3">📅 {dateFormat(bug.deadline,"dS mmm yyyy")}</p>
              </div>
            </Col>
            <Col md={6} className="text-end">
              <Badge bg="success" className="px-3 py-2">
                In Progress 
              </Badge>
              <p className='mt-2' >Last Updated: 📅 {dateFormat(bug.updated_date,"dS mmm yyyy")}</p>
            </Col>
          </Row>

          <button  onClick={()=>setpopup(true)} className="btn btn-primary mt-4 w-fit">
            Submit Report
          </button>
        </Card>
    </>
  )
}

export default BugCourseCard
